import { ReactNode } from "react";
import { Card } from "shared/components/Card";

interface SectionCardProps {
  title: string;
  children: ReactNode;
  headerExtra?: ReactNode;
  footer?: ReactNode;
}

export const SectionCard = ({
  title,
  children,
  headerExtra,
  footer
}: SectionCardProps) => {
  return (
    <Card>
      <div className="px-8 border-b border-alpha-40 flex items-center justify-between">
        <h3 className="text-base font-bold py-6">{title}</h3>
        {headerExtra}
      </div>
      <div className="py-6 px-8">
        {children}
        {footer}
      </div>
    </Card>
  );
};
